export default "__VITE_ASSET__DaTkDqus__"